





































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { calendarPanel,NumberKeyboard,logoutPanel } from "@/components";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { TbOrderPad, TbReturnOrder,TbGoods } from '@/http';
dayjs.locale('zh-cn')
import selectReturnProduct from "./selectReturnProduct.vue";
import editReturnProduct from "./editReturnProduct.vue";
import returnDetailPopPanel from "./returnDetailPopPanel.vue";
import { Toast } from 'vant';
import confirmReturnPanel from "./confirmReturnPanel.vue";
import returnResultPanel from "./returnResultPanel.vue";
@Component({
    components: {
        calendarPanel,NumberKeyboard,logoutPanel,selectReturnProduct,editReturnProduct,returnDetailPopPanel,confirmReturnPanel,returnResultPanel
    },
})
export default class returnOrder extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };
    fmoney = fmoney;

    /**查询项 */
    searchValue={
        goods:"",
        key:"",
        type:null,
        start:"",
        end:"",
        name:"",
        skip:0,
        count:10,
    }

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    userInfo:any={};
    
    /**已选退货列表 */
    returnList = [];

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**选择退回商品 */
    srpShow = false;
    detailForm:any={};
    selectedOrder:any={};

    /**长按删除 */
    Loop=null;
    deleteId = "";

    /**编辑退回商品 */
    editShow = false;
    eidtForm:any = {};

    /**退货确认弹窗 */
    detailShow = false;
    returnConfirmForm:any = {};
    isloading = false;
    defaultDate=[];

    confirmReturnShow=false;
    returnResultShow=false;
    returnForm:any={};
    oldReturnedInfo={};
    isRRloading=false;

    /**退回数量 */
    get returnNumAll(){
        let val = 0;
        let arr = this.returnList.filter(v=>Number(v.returnNum)>0).map(v=>v.returnNum);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    /**退回金额 */
    get returnPriceAll(){
        let val = 0;
        let arr = this.returnList.filter(v=>Number(v.actualReturnPriceTotal)>0).map(v=>v.actualReturnPriceTotal);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(a,b))
        }
        return val;
    }
    isOnReset = false;
    scantype ="";
    isOnlineFail=false;

    @Watch('searchValue.key')
    keyChange(){
        if(this.isOnReset||this.scantype=='1') return;
        this.getList();
        this.$nextTick(()=>{
            this.scantype = "";
        })
    }
    @Watch('searchValue.goods')
    goodsChange(){
        if(this.isOnReset||this.scantype=='2') return;
        this.getList();
        this.$nextTick(()=>{
            this.scantype = "";
        })
    }

    created() {
    }
    
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));

        this.getInputFocus()
        document.addEventListener('click',this.chargeInputFocus)
    }

    async scanInput(val){
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            this.scantype="1";
            this.searchValue.key="";
            this.searchValue.goods = res.barCode?res.barCode:'';
        }else{
            this.scantype="2";
            this.searchValue.goods = "";
            this.searchValue.key = val;
        }
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input'&&event.target.tagName.toLowerCase() != 'textarea') {
            this.getInputFocus()
        }
    }

    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if(this.isFocus){
            this.searchValue.goods = event.target.value
        }else{
            if (event.key === 'Enter' || event.keyCode == 13) {
                let code = this.scanCodes?this.scanCodes:event.target.value
                this.scanInput(code)
    
                this.scanCodes = ''
            return
            }
        }
    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)
    }

    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.searchValue.count=10;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbOrderPad.GetOrderList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId,
                orderStatus:2
            }))
            this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            this.isOnReset = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            
            }
    }

    async getList(){
        this.onRefresh();
        // this.finished = false;
        // this.list = [];
        // this.searchValue.skip=0;
        // this.searchValue.count=10;
        // this.total = 0;
        // this.currentPage = 1;
        
        //     let res = await TbOrderPad.GetOrderList(Object.assign({},this.searchValue,{
        //         shopId:this.userInfo.shopId,
        //         orderStatus:2
        //     }))
        //     this.list = res.items;
        //     this.total  = res.totalCount;
    }

    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
        this.searchValue.type = 6;
        this.pickerShow = false;
        this.setTimeSearch();
        document.addEventListener('click',this.chargeInputFocus)

    }
    closeTime(){
        this.pickerShow = false;
    }
  
    async setTimeSearch(){
        this.searchValue.start=this.startDate+" 00:00:00";
        this.searchValue.end=this.endDate+" 23:59:59";
        await this.getList();
    }
    /**重置 */
    resetSearch(){
        this.scantype = "";
        this.isOnReset = true;
        this.list = [];
        this.searchValue={
            goods:"",
            key:"",
            type:null,
            start:"",
            end:"",
            name:"",
            skip:0,
            count:10,
        }
        this.startDate = "";
        this.endDate = "";
        let date = new Date();
        this.defaultDate = [date,date];
        this.getList();
    }
    finishPhone(val){
        this.searchValue.key = val;
    }

    async viewDetail(id){
        if(this.returnList.length>0){
            this.tipTitle = "操作提醒";
            this.tipText = `退货列表中已有待退货商品`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 5;
            this.tipShow = true;
            return;
        }
        await this.getDetail(id);
        await this.getReturnedInfo(id);
        this.srpShow = true;
    }
    async getReturnedInfo(id){
        let res= await TbReturnOrder.GetReturnOrderNum({orderId:id});
        this.oldReturnedInfo = res;
    }
    async getDetail(id){
        let res = await TbOrderPad.GetOrderReturnById({id:id});
        res.items=res.items.map(v=>{
            return{
                ...v,
                checked:false,
                newReturnNum:0
            }
        })
        this.detailForm = res;
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
        /**清空退货列表 */
        case 1:
            this.returnList=[];
            this.selectedOrder = {};
            this
            break;
        /**退货列表为空提醒 */
        case 2:
            break;
        /**整单退回-退货列表为空提醒 */
        case 3:
            break;
        /**退回列表-长按删除 */
        case 4:
            this.returnList = this.returnList.filter(v=>v.id!=this.deleteId);
            if(this.returnList.length==0){
                this.selectedOrder = {};
            }
            break;
        /**退货列表中已有待退货商品 */
        case 5:
            break;
        
       
        default:
            break;
       }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    /**删除 */
    deleteFun(){
        if(this.returnList.length==0) return;
        this.tipTitle = "操作提醒";
        this.tipText = `确认清空退货商品列表吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.tipShow = true;
    }
    /**退款 */
    returnFun(){
        if(this.returnList.length==0){
            this.showEmptyTip();
            return;
        }
        

        let sellingPriceTotal,finalPriceTotal,vipVal,cashVal = 0;
        let arr1 = this.returnList.filter(v=>v.sellingPriceTotal).map(v=>v.sellingPriceTotal);
        let arr2 = this.returnList.filter(v=>v.finalPriceTotal).map(v=>v.finalPriceTotal);
        sellingPriceTotal = arr1.length>0 ? arr1.reduce((a,b)=>calculate.addition(a,b)):0;
        finalPriceTotal = arr2.length>0 ? arr2.reduce((a,b)=>calculate.addition(a,b)):0;
        /**计算退回金额 */
        /**会员卡支付 */
        if(this.selectedOrder.paymentMethod==1){
            vipVal = this.returnPriceAll;
            cashVal = 0;
        }else{
            /**组合支付 */
            if(this.selectedOrder.calcReturnInfo.maxCardPrice){
                if(this.selectedOrder.calcReturnInfo.maxCardPrice>=this.returnPriceAll){
                    vipVal = this.returnPriceAll;
                    cashVal = 0;
                }else{
                    vipVal = this.selectedOrder.calcReturnInfo.maxCardPrice;
                    cashVal = calculate.subtraction(this.returnPriceAll,this.selectedOrder.calcReturnInfo.maxCardPrice);
                }
            }else{
                vipVal = 0;
                cashVal = this.returnPriceAll;
            }
        }
        let obj = {
            sellingPriceTotal:sellingPriceTotal,
            finalPriceTotal:finalPriceTotal,
            returnPriceAll:this.returnPriceAll,
            returnNumAll:this.returnNumAll,
            vipVal:vipVal,
            cashVal:cashVal,
        }
        this.returnConfirmForm = Object.assign({},this.selectedOrder,obj);
        this.isOnlineFail = false;
			this.$nextTick(()=>{
				this.confirmReturnShow = true;
			})

    }
    /**选择退回商品弹窗 */
    closeSelectProduct(){
        this.srpShow = false;
    }
    /** */
    showEmptyTip(){
        this.tipTitle = "操作提醒";
        this.tipText = `请先添加需要退回的商品`;
        this.btnNums=1;
        this.confirmText = "确认";
        this.cancelText = ""
        this.tipType = 2;
        this.tipShow = true;
    }
    /**确定退回 */
    confirmReturn(obj){
        console.log('退回退回',obj)
        if(obj.calcReturnInfo.items.length==0){
            this.showEmptyTip();
            return;
        }
        this.selectedOrder = obj;
        this.formateReturnList(obj.calcReturnInfo.items);
        this.srpShow = false;
    }
    /**整单退回 */
    returnAll(obj){
        if(obj.calcReturnInfo.items.length==0){
            this.tipTitle = "操作提醒";
            this.tipText = `暂无可退货的商品`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 3;
            this.tipShow = true;
            return;
        }
        this.selectedOrder = obj;
        this.formateReturnList(obj.calcReturnInfo.items);
        this.srpShow = false;
    }
    formateReturnList(list){
        this.returnList = list.map(v=>{
            return{
                ...v,
                actualReturnPrice:v.finalPrice,
                sellingPriceTotal:v.totalSellPrice,
                finalPriceTotal: v.totalPrice,
                actualReturnPriceTotal: v.totalPrice,
            }
        })
    }

    /**退回列表-长按删除 */
    touchstart(item){
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            this.tipTitle = "操作提醒";
            this.tipText = `确定将该商品从退货列表里删除吗？`;
            this.btnNums=2;
            this.confirmText = "确定";
            this.cancelText = "取消"
            this.tipType = 4;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    touchend(){
        clearInterval(this.Loop);
    }

    /**编辑商品-弹窗 */
    closeEdit(){
        this.editShow = false;
    }
    clickCount:number = 0;
    async editRow(item){
        this.clickCount++
        setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                await this.getReturnOrderInfo(item);
                this.$nextTick(()=>{
                    this.editShow = true;
                })
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.touchstart(item)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
        },300)
       
    }
    async getReturnOrderInfo(item){
        console.log('item',item);
        
        let res = await TbReturnOrder.GetReturnOrderInfo({
            orderId:item.orderId,
            items:[{
                goodsItemId:item.goodsItemId,
                num:item.returnNum,
                isGift:item.isGift
            }]
        })
        let resOrder = await TbOrderPad.GetOrderReturnById({id:item.orderId});
        
        let canReturnNum = resOrder.items.findIndex(v=>v.goodId==item.goodId&&v.isGift==item.isGift&&v.goodsItemId==item.goodsItemId)>-1?resOrder.items.find(v=>v.goodId==item.goodId&&v.isGift==item.isGift&&v.goodsItemId==item.goodsItemId).returnNum:0;
        let canReturnPriceTotal = resOrder.items.findIndex(v=>v.goodId==item.goodId)>-1?resOrder.items.find(v=>v.goodId==item.goodId).totalPrice:0;
        this.eidtForm = res.items&&res.items.length>0?Object.assign({},res.items[0],{canReturnNum:canReturnNum,canReturnPriceTotal:canReturnPriceTotal,nowtotalPrice:res.items[0].totalPrice!=item.actualReturnPriceTotal?item.actualReturnPriceTotal:res.items[0].totalPrice}):{};
        console.log('eidtForm',this.eidtForm);
        
    }

    editReturnProduct(item){
        let index = this.returnList.findIndex(v=>v.id==this.eidtForm.id);
        
        if(index>-1){
            this.$set(this.returnList[index],"returnNum",item.num);
            this.$set(this.returnList[index],"sellingPriceTotal",item.sellingPriceTotal);
            this.$set(this.returnList[index],"finalPriceTotal",item.actualReturnPriceTotal);
            this.$set(this.returnList[index],"actualReturnPriceTotal",item.sellingPrice);
        }
    }
    closeDetail(){
        this.detailShow = false;
    }
    /**确定退货 */
    async returnConfirm(returnConfirmForm){
			
		    if(this.isloading) return;
           
           Toast.loading({
                message: "退款中...",
                duration: 0, // toast不消失
            });
		    this.isloading = true
		    try {
		        let res =await TbReturnOrder.PostReturnOrderV2({
		            orderId:this.selectedOrder.id,
		            shopId:this.selectedOrder.shopId,
		            cardPrice:returnConfirmForm.vipVal,
		            offlinePrice:returnConfirmForm.cashVal,
		            returnPrice:this.returnPriceAll,
					weChatRefundPrice:returnConfirmForm.wechatVal,
					alipayRefundPrice:returnConfirmForm.aliVal,
					offlineWeChatRefundPrice:returnConfirmForm.offlineWechatVal,
					offlineAlipayRefundPrice:returnConfirmForm.offlineAliVal,
		            items:this.returnList.map(v=>{
		                return{
		                    goodId: v.goodId,
		                    goodsItemId: v.goodsItemId,
		                    unitPrice: v.actualReturnPriceTotal,
		                    num: v.returnNum,
		                    isGift: v.isGift,
		                }
		            })
		        })
				if((this.selectedOrder.paymentMethod==3||this.selectedOrder.paymentMethod==4)&&returnConfirmForm.isOnlineRefund&&!this.isOnlineFail){
					this.returnForm = Object.assign({},res,{
						paymentMethod:this.selectedOrder.paymentMethod
					});
					 this.confirmReturnShow = false;
					this.returnResultShow = true;
					 this.isloading = false;
                     Toast.clear();
				}else{
					Toast("退款成功");
					this.confirmReturnShow = false;
					this.isloading = false;
                     Toast.clear();
					this.returnList = [];
					this.selectedOrder = {};
					this.onRefresh();
				}
		    } catch (error) {
		        this.isloading = false;
                 Toast.clear();
		    }
		}
        cancelReturn(){
			this.confirmReturnShow = false;
		}
		onReturnResultClose(){
			this.returnResultShow = false;
			this.onClear();
		}
		async closeOrder(){
            if(this.isRRloading) return;
			this.returnResultShow = false;
			await this.closeOrderFun();
			await this.onClear();
		}
		async closeOrderFun(){
            if(this.isRRloading) return;
			this.isRRloading = true;
            try {
                let res = await TbReturnOrder.CloseOnlineReturnOrder({returnOrderId:this.returnForm.returnOrderId});
                this.isRRloading = false;
            } catch (error) {
                this.isRRloading = false;
            }
		}
		async changeReturnMethod(needClose){
            if(this.isRRloading) return;
			this.returnResultShow = false;
			if(needClose){
				await this.closeOrderFun();
			}
			this.isOnlineFail = true;
			this.$nextTick(()=>{
				this.confirmReturnShow = true;
			})

		}
		async returnAgain(){
            if(this.isRRloading) return;
			this.isRRloading = true;
			Toast.loading({
                message: "退款中...",
                duration: 0, // toast不消失
            });
            try {
                let res= await TbReturnOrder.AgainOnlineReturnOrder({
                    orderId:this.selectedOrder.id,
                    returnOrderId:this.returnForm.returnOrderId
                })
                this.returnForm = Object.assign({},res,{
                    paymentMethod:this.selectedOrder.paymentMethod
                });
                this.isRRloading = false;
                Toast.clear();
                this.$nextTick(()=>{
                    this.$refs['returnResultPanelRef'].onRefresh();
                })
                
            } catch (error) {
                this.isRRloading = false;
                Toast.clear();
            }
		}
		async refreshStatus(){
            try {
                let res = await TbReturnOrder.GetReturnOrderStatus({
                    returnOrderId:this.returnForm.returnOrderId
                })
                this.returnForm = Object.assign({},res,{
                    paymentMethod:this.selectedOrder.paymentMethod
                });
                this.$nextTick(()=>{
                    this.$refs['returnResultPanelRef'].onRefresh();
                })
            } catch (error) {
                this.onReturnResultClose();
            }
		}
		onClear(){
			this.returnList = [];
			this.selectedOrder = {};
			this.onRefresh();
		}
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/returnOrder.vue